///<reference path="../../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/common/decorators.ts" />
///<reference path="../../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/common/models/model.ts" />
namespace TotalPoll {
    import Model = TotalCore.Common.Models.Model;

    export class Entry extends Model {

        constructor(attrs) {
            super(attrs);
            let details = angular.copy( this.get('details', {}) );
            delete details.skipped;
            this.set('flattenDetails', this.flatten(details));
        }

        getAction() {
            return this.get('action');
        }

        getDate() {
            return this.get('date');
        }

        getDetails() {
            return this.get('flattenDetails', {});
        }

        getEntry() {
            return this.get('entry');
        }

        getIP() {
            return this.get('ip');
        }

        getPollEditLink() {
            return this.get('poll.admin.editLink');
        }

        getPollTitle() {
            return this.get('poll.title');
        }

        getStatus() {
            return this.get('status');
        }

        getUTCDate() {
            return `${this.get('date').substring(0, 10)} @ ${this.get('date').substring(11, 16)}`;
        }

        getUser(field?) {
            if (field) {
                return this.get(`user.${field}`);
            }

            return this.get('user');
        }

        getUseragent() {
            return this.get('useragent');
        }

        isAccepted() {
            return this.getStatus() === 'Accepted';
        }

        isRejected() {
            return this.getStatus() === 'Rejected';
        }

        private flatten(data) {
            var result = {};

            function recurse(cur, prop) {
                if (Object(cur) !== cur) {
                    result[prop] = cur;
                } else if (Array.isArray(cur)) {
                    for (var i = 0, l = cur.length; i < l; i++)
                        recurse(cur[i], prop + "[" + i + "]");
                    if (l == 0)
                        result[prop] = [];
                } else {
                    var isEmpty = true;
                    for (var p in cur) {
                        isEmpty = false;
                        recurse(cur[p], prop ? prop + "." + p : p);
                    }
                    if (isEmpty && prop)
                        result[prop] = {};
                }
            }

            recurse(data, "");
            return result;
        }
    }
}
